import { site } from './site'

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'What exactly is Physical Education Ready?',
    answer:
      'It is a complete digital teaching system containing 10 structured PE volumes for Elementary and Secondary education, plus 5 practical bonuses. It is designed to help teachers plan faster and deliver progressive, organized, and inclusive lessons.',
  },
  {
    question: 'Is this a course?',
    answer:
      'No. Physical Education Ready is not a course or subscription. It is a collection of ready-to-use digital teaching resources.',
  },
  {
    question: 'Who is it designed for?',
    answer:
      'It is designed for Elementary and Secondary Physical Education teachers, including new teachers, experienced teachers, substitute teachers, coaches, and educators who need structured practical resources.',
  },
  {
    question: 'What format will I receive?',
    answer:
      'You will receive digital resources that can be accessed after purchase. Update this answer with the exact downloadable formats and delivery method used by the store.',
  },
  {
    question: 'Does it include both Elementary and Secondary content?',
    answer: 'Yes. The complete package includes five Elementary volumes and five Secondary volumes.',
  },
  {
    question: 'Can I use it with mixed-ability classes?',
    answer:
      'Yes. The activities include adaptable options and inclusive teaching considerations. Teachers should still apply professional judgment and follow local school, safety, and accessibility policies.',
  },
  {
    question: 'Do I need special equipment?',
    answer:
      'Many activities use common PE equipment, and the included No-Equipment PE bonus provides additional options for limited-resource environments.',
  },
  {
    question: 'Is this a subscription?',
    answer: 'No. It is a one-time payment with lifetime access to the purchased digital files.',
  },
  {
    question: 'How do I receive the materials?',
    answer:
      'Access instructions are sent digitally after payment. Update this answer to match the exact delivery process used by the store.',
  },
  {
    question: 'Can I share the files with other teachers?',
    answer:
      'The purchase is licensed for individual use by the buyer unless a separate school or team license is offered. Add the final approved licensing terms before publishing.',
  },
  {
    question: 'What if the resource is not right for me?',
    answer: `Your purchase is covered by the published ${site.guaranteeDays}-day guarantee. Review the refund policy for complete terms.`,
  },
]
